import React, { Component } from 'react';

import '../../assets/style/itemStyle/membership.scss';
import { getLocalStorage, openLoginPopup, roll, setSessionStorage } from '../../untils/auth';

import ContentCard from 'components/ContentCard';
import FAQ from 'components/FAQ';
import HeaderMeta from 'components/headerMeta/HeaderMeta';
import { buildPageBreadcrumb } from 'untils/jsonLdSchemas';
import Footer from '../../components/layout/Footer';
import { getSaleMembershipCard, getUserMembershipCard } from '../../services/member';
import MembershipType from './components/MembershipType';

const QuestionLists = [
  {
    question: 'What are the benefits of private jet memberships with Airacer?',
    answer:
      'While Airacer isn’t a private airline, membership in our program gives you access to many of the premium perks you’d find when flying with large airlines and many other benefits that you can only get from Airacer, including access to a dedicated flight account manager and a global support team.',
  },
  {
    question: 'Is a private jet better than flying first class?',
    answer:
      'For most people, yes. Private flights offer unmatched privacy, flexibility, and personalized service that first-class flights cannot provide.',
  },
  {
    question: 'Are jet membership programs worth it?',
    answer:
      'A private jet membership is a good investment if you frequently travel and value convenience, privacy, comfort, and exclusive benefits. The 24/7 access to our global service support team means that you’ll always get help whether you need to book a flight quickly or change your plans.',
  },
  {
    question: 'What amenities can I expect on a private jet?',
    answer:
      'While the amenities of private jets vary based on their class and model, most include luxurious seating, in-flight catering, high-speed Wi-Fi, entertainment systems, and personalized service.',
  },
  {
    question: 'What types of planes are available with a private jet charter membership?',
    answer:
      'Jet charter memberships offer access to various aircraft, including light, midsize, and heavy jets, for different travel distances, depending on your needs.',
  },
  {
    question: 'What does a private jet membership cost?',
    answer:
      'The Airacer Jet Club has three membership levels. The Freemium level is free. The Gold level costs $250/month ($3,000 annual total) or you can get a 30% discount by paying a once-yearly fee of $2,100. The Platinum level costs $450/month ($5,400 annual total) or you can receive a 30% discount if you pay a once-yearly fee of $3,780/year.',
  },
];

export default class MembershipCard extends Component {
  state = {
    programs: new Map(),
    cardShow: false, //用户有无会员卡
  };
  // 用户登录或游客登录
  goLogin = (data) => {
    setSessionStorage('memberPrice', JSON.stringify(data ?? ''));
    this.props.history.push(this.state.cardShow ? `/membershipCards` : `/addCardInformation`);
  };
  // 登录弹窗
  openLogin = () => {
    //未登录，打开登陆弹窗
    if (!getLocalStorage('token')) {
      return openLoginPopup('open');
    }
  };

  // 判断用户有无会员卡
  getUserMembershipCard = () => {
    getUserMembershipCard().then((res) => {
      if (res.code) {
        this.setState({
          cardShow: !!res.data.cards,
        });
      }
    });
  };

  componentDidMount() {
    roll(0);
    getSaleMembershipCard('equity').then((res) => {
      if (res.code) {
        this.setState({
          programs: new Map(res.data.programs.map((p) => [p.cardType, p])),
        });
      }
    });

    if (getLocalStorage('user')) {
      // 获取用户有无会员卡
      let data = JSON.parse(getLocalStorage('user'));
      this.setState({
        cardShow: !!data.membershipCardType,
      });
    }
  }
  render() {
    let { programs } = this.state;

    return (
      <>
        <HeaderMeta
          type="memberships"
          jsonLd={[buildPageBreadcrumb('Membership', '/membership')]}
        />
        <div>
          <div className="member-banner">
            <h1>Private Jet Membership</h1>
            <img src="imgs/webp/membership/banner.webp" alt="private jet charter memberships" />
          </div>
          <div className="member-top">
            <div className="img-title">
              <span className="member-title">The Freedom to Fly Anywhere, Anytime</span>
              <img
                src={require('../../assets/imgs/svg/member-plane.svg').default}
                alt="plane"
                className="member-plane"
              />
            </div>
            <div className="member-text">
              <p>
                <i className="bg-image"></i> The Airacer private jet membership program provides you
                with the flexibility to fly anywhere in the world that is accessible by private air
                charter whenever you need to travel.
              </p>
              <p>
                <i className="bg-image"></i> We deliver the best solutions available and offer
                access to aircraft in every market around the globe.
              </p>
              <p>
                <i className="bg-image"></i> Our team is available 24/7 to arrange the other
                elements of your journey, including accommodations, transfers, and even tickets for
                scheduled flights.
              </p>
            </div>
          </div>
          <div className="member-bottom">
            <div className="member-bottom-text">
              Frequent Flyer? Explore more flexible private travel solutions when you purchase
              flight hours with the button on the right side :
            </div>

            <a className="member-bottom-link" href="/jet-card-membership" target="_blank">
              Jet Card Membership
            </a>
          </div>
        </div>
        <div className="member-program">
          <h2 className="title">Airacer Jet Club Membership Program</h2>
          <p>Sign up now for 100 free credits to use toward your first trip!</p>
          <p>
            Become a member today and choose from one of our Airacer Jet Card charter jet
            memberships.
          </p>
        </div>

        <MembershipType
          trailData={programs.get('Trial')}
          goldData={programs.get('Gold')}
          platinumData={programs.get('Platinum')}
          goLogin={this.goLogin}
        />

        <div className="member-work">
          <ContentCard
            item={{
              picture: 'imgs/webp/membership/plane.webp',
              altImage: 'A private jet taking off against the backdrop of a city skyline.',
            }}
          >
            <h2 className="title">{'How Airacer’s Private Plane Membership Works'}</h2>

            <p>
              Our memberships function almost like a private jet subscription. Whenever you need to
              fly, you will get help from a dedicated personal flight account manager who will help
              you plan every part of your trip, from booking a flight to setting up chauffeur
              services to and from the airport. If you have special dietary needs or are bringing
              your pets on a pet-friendly flight, your account manager will ensure your journey is
              seamless, safe, and comfortable.
            </p>

            <h2 className="title">Sign Up for the Airacer Jet Club Today</h2>

            <p>
              {
                'Whether you’re flying for business or leisure, our membership unlocks seamless private travel tailored to your needs. Join today and enjoy the freedom to fly anywhere, anytime.'
              }
            </p>
          </ContentCard>
          <FAQ
            HeadTitle={'Private Jet Membership FAQs'}
            HeadDesc={'Have more questions about the Airacer Jet Club? We have answers.'}
            QuestionLists={QuestionLists}
          />
        </div>

        <Footer />
      </>
    );
  }
}
